import React from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { ComparatorModel, getBestComparatorVehiclesPath, SuggestedLinksEntity } from 'client/data/models/comparator';
import { MM_VS_MM_LINKS_SECTION_ID } from 'site-modules/comparator/constants/comparator';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { parseType } from 'site-modules/comparator/utils/comparator';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { getPlural } from 'client/utils/plural';

import { SectionLinks } from './section-links';

function SuggestedLinksSection({
  links = [],
  header = '',
  isMobile = false,
  noFollow = false,
  isMakeModelVsMakeModelSection = false,
}) {
  const MAX_INITIAL_LINKS = isMobile ? 4 : 8;
  const linksBeforeCollapse = links.slice(0, MAX_INITIAL_LINKS);
  const linksCollapsed = links.slice(MAX_INITIAL_LINKS);

  return (
    <section className="suggested-links-section mt-2">
      <h2 className="heading-3 mt-0 mb-1">{header}</h2>
      <SectionLinks links={linksBeforeCollapse} isMobile={isMobile} noFollow={noFollow} />
      {linksCollapsed.length ? (
        <ContentCollapse
          showBtnBelow
          trackingId={null}
          btnContainerClasses="mx-0 mb-0_5 mt-0_5"
          justify="justify-content-start"
          textOpen={
            isMakeModelVsMakeModelSection ? 'See fewer comparisons' : `See fewer ${parseType(header)} comparisons`
          }
          textClosed={
            isMakeModelVsMakeModelSection ? 'See more comparisons' : `See more ${parseType(header)} comparisons`
          }
          btnArrowClasses="small text-primary-darker"
          btnSize={null}
          btnColor="link"
          btnClasses="text-gray-darker size-16 p-0 pos-s"
          isEclipseFade={false}
        >
          <SectionLinks links={linksCollapsed} isMobile={isMobile} noFollow={noFollow} />
        </ContentCollapse>
      ) : null}
    </section>
  );
}

SuggestedLinksSection.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({})),
  header: PropTypes.string,
  isMobile: PropTypes.bool,
  noFollow: PropTypes.bool,
  isMakeModelVsMakeModelSection: PropTypes.bool,
};

export function SuggestedLinksUI({ suggestedLinks = null, bestComparatorVehicles = null, isMobile = false }) {
  return (
    <Container>
      <FeatureFlag name="showGraphqlComparatorLinks">
        {bestComparatorVehicles &&
          bestComparatorVehicles.map(({ header, links }) => (
            <SuggestedLinksSection
              key={header}
              links={links}
              header={`Compare ${getPlural(header, 2, 2, true)}`}
              isMobile={isMobile}
              noFollow
            />
          ))}
      </FeatureFlag>

      {!!get(suggestedLinks, 'length') &&
        suggestedLinks.map(({ id, links, header }) =>
          id === MM_VS_MM_LINKS_SECTION_ID ? (
            <SuggestedLinksSection
              key={id}
              links={links}
              header={header}
              isMobile={isMobile}
              isMakeModelVsMakeModelSection
            />
          ) : (
            <FeatureFlag name="showComparatorLinks" key={id}>
              <SuggestedLinksSection key={id} links={links} header={header} isMobile={isMobile} noFollow />
            </FeatureFlag>
          )
        )}
      <hr />
    </Container>
  );
}

SuggestedLinksUI.propTypes = {
  suggestedLinks: SuggestedLinksEntity,
  bestComparatorVehicles: SuggestedLinksEntity,
  isMobile: PropTypes.bool,
};

const stateToPropsConfig = {
  suggestedLinks: bindToPath(() => 'suggestedLinks', ComparatorModel),
  bestComparatorVehicles: bindToPath(() => getBestComparatorVehiclesPath(), ComparatorModel),
};

export const SuggestedLinks = connectToModel(SuggestedLinksUI, stateToPropsConfig);
